// extracted by mini-css-extract-plugin
export default {"dropDownMenu":"statistic_dropDownMenu__hQLec","timePeriodSelect":"statistic_timePeriodSelect__K8pL4","mainContainer":"statistic_mainContainer__7wMgm"};